import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import "../index.css"

// Inputs
import { Button, CheckboxField } from '../../../helpers'

// common components
import Loading from "../../../common/Loading"
import BillingAddressCards from "../../../common/BillingAddressCards"
import ShippingAddressCards from "../../../common/ShippingAddressCards"


// Child Components
import DispatchNote from './DispatchNoteList'

// apis
import { insertDeliveryChallan } from '../../../services/api/deliveryChallan'
import { fetchBuyerPOs } from '../../../services/redux/reducers/buyerPO/buyerPO'

// Redux
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

// utils
import { round } from '../../../utils'

const CreateDeliveryChallan = (props) => {
    const { selectedBuyerPODispatchNotes, dispatchNoteItems, buyerCompanyBillAddrs, buyerCompanyBranchShipAddrs, buyerCompanyPMBillAddrs, userId, selectedBuyerPOs, statesList } = props
   
    const [selectedInvoiceDispatchNotesIds, setSelectedInvoiceDispatchNotesIds] = useState([])
    const [reqWiseGroupedDispatchNoteItems, setReqWiseGroupedDispatchNoteItems] = useState({})
    const [selectedBuyerBillAddrId, setSelectedBuyerBillAddrId] = useState(null)
    const [selectedBuyerShipAddrId, setSelectedBuyerShipAddrId] = useState(null)
    let [buyerReqWiseDispatchNoteItems, setBuyerReqWiseDispatchNoteItems] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const searchParams = useSelector(state => state.buyerPOData.searchParams)
    const paginationParams = useSelector(state => state.buyerPOData.paginationParams)
    
    const dispatch = useDispatch()

    useEffect(() => {
        
        if (props.buyerCompanyBillAddrs.length === 1) {
            setSelectedBuyerBillAddrId(props.buyerCompanyBillAddrs[0].billAddrId)
        }

        if (props.buyerCompanyBranchShipAddrs.length === 1) {
            setSelectedBuyerShipAddrId(props.buyerCompanyBranchShipAddrs[0].shipAddrId)
        }
    }, [])


    const handleShippingAddress = (shipAddrId) => {
        if (shipAddrId) {
            setSelectedBuyerShipAddrId(shipAddrId)
        } else {
            setSelectedBuyerShipAddrId(null)
        }
    }

    const handleBillingAddress = (billAddrId) => {
        if (billAddrId) {
            setSelectedBuyerBillAddrId(billAddrId)
        } else {
            setSelectedBuyerBillAddrId(null)
        }
    }


    const handleAllDispatchCheckBox = (e) => {
        const dispatchNoteIds = selectedBuyerPODispatchNotes.map(eachDispatchNote => eachDispatchNote.dispatchNoteId)
        if (e.checked) {
            setSelectedInvoiceDispatchNotesIds(dispatchNoteIds)
            let reqWiseDispatchNoteItems = {}
            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (!reqWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId]) {
                    reqWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId] = [];
                }
                
                let relatedBuyerReqDispatchNoteItem = buyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
                if (!relatedBuyerReqDispatchNoteItem) {
                    eachDispatchNoteItem.totalQty = eachDispatchNoteItem.qty
                    buyerReqWiseDispatchNoteItems.push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                } else {
                    relatedBuyerReqDispatchNoteItem.qty += eachDispatchNoteItem.qty
                    relatedBuyerReqDispatchNoteItem.totalQty += eachDispatchNoteItem.qty
                }

                reqWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId].push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))

            })
            setBuyerReqWiseDispatchNoteItems([...buyerReqWiseDispatchNoteItems])
            setReqWiseGroupedDispatchNoteItems(reqWiseDispatchNoteItems)
        } else {
            setSelectedInvoiceDispatchNotesIds([])
            setReqWiseGroupedDispatchNoteItems({})
            setBuyerReqWiseDispatchNoteItems([])
        }
    }

    const handleSelectDispatchCheckBox = (selectedDispatchNoteId) => {
        if (selectedInvoiceDispatchNotesIds.includes(selectedDispatchNoteId)) {
            const relatedDispatchNotesIds = selectedInvoiceDispatchNotesIds.filter(eachDispatchNoteId => eachDispatchNoteId !== selectedDispatchNoteId)
            setSelectedInvoiceDispatchNotesIds(relatedDispatchNotesIds)
            Object.keys(reqWiseGroupedDispatchNoteItems).map((buyerReqItemId, index) => {
                let dispatchNoteItems = reqWiseGroupedDispatchNoteItems[buyerReqItemId]
                const relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItemId => eachDispatchNoteItemId.dispatchNoteId !== selectedDispatchNoteId)

                reqWiseGroupedDispatchNoteItems[buyerReqItemId] = relatedDispatchNoteItems

                if (relatedDispatchNoteItems.length === 0) {
                    delete reqWiseGroupedDispatchNoteItems[buyerReqItemId]
                }
            })

            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (eachDispatchNoteItem.dispatchNoteId === selectedDispatchNoteId) {
                    let relatedBuyerReqDispatchNoteItem = buyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
                    if(relatedBuyerReqDispatchNoteItem){
                        relatedBuyerReqDispatchNoteItem.qty -= eachDispatchNoteItem.qty
                        relatedBuyerReqDispatchNoteItem.totalQty -= eachDispatchNoteItem.qty
                        relatedBuyerReqDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, 4)

                        if (relatedBuyerReqDispatchNoteItem.qty === 0) {
                            buyerReqWiseDispatchNoteItems = buyerReqWiseDispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteItemId !== relatedBuyerReqDispatchNoteItem.dispatchNoteItemId)
                        }
                    }
                }
            })
            
            setBuyerReqWiseDispatchNoteItems([...buyerReqWiseDispatchNoteItems])
            setReqWiseGroupedDispatchNoteItems({ ...reqWiseGroupedDispatchNoteItems })
        } else {
            const relatedDispatchNotesIds = [...selectedInvoiceDispatchNotesIds, selectedDispatchNoteId]
            setSelectedInvoiceDispatchNotesIds(relatedDispatchNotesIds)

            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (eachDispatchNoteItem.dispatchNoteId === selectedDispatchNoteId) {
                    if (!reqWiseGroupedDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId]) {
                        reqWiseGroupedDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId] = [];
                    }

                    let relatedBuyerReqDispatchNoteItem = buyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
                    if(!relatedBuyerReqDispatchNoteItem){
                        eachDispatchNoteItem.totalQty = eachDispatchNoteItem.qty
                        eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, 4)
                        buyerReqWiseDispatchNoteItems.push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                    }else{
                        relatedBuyerReqDispatchNoteItem.qty += eachDispatchNoteItem.qty
                        relatedBuyerReqDispatchNoteItem.totalQty += eachDispatchNoteItem.qty
                        relatedBuyerReqDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, 4)
                    }

                    reqWiseGroupedDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId].push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                }
            })
            
            setBuyerReqWiseDispatchNoteItems([...buyerReqWiseDispatchNoteItems])
            setReqWiseGroupedDispatchNoteItems({ ...reqWiseGroupedDispatchNoteItems })
        }
    }

    const onSubmitCreateDeliveryChallan = async () => {
        const relatedBuyerCompanyTags = selectedBuyerPOs[0]?.companies?.tags

        if(selectedInvoiceDispatchNotesIds.length === 0){
            return dispatch(raiseToast({severity:'warn', detail: "Please select dispatch notes", life: 3000}))
        }
        
        if (relatedBuyerCompanyTags?.shouldEnforceDispatch){
            if (selectedBuyerPODispatchNotes.length !== selectedInvoiceDispatchNotesIds.length){
                return dispatch(raiseToast({severity:'warn', detail: "Please select all the dispatch notes", life: 3000}))
            }
        }

        if(!selectedBuyerShipAddrId){
            return dispatch(raiseToast({severity:'warn', detail: "Please select shipping address", life: 3000}))
        }

        if(!selectedBuyerBillAddrId){
            return dispatch(raiseToast({severity:'warn', detail: "Please select billing address", life: 3000}))
        }

        let selectedDispatchNoteBuyerPOIds = _.uniq(_.map(dispatchNoteItems, 'buyerPOId'))
        let relatedBuyerPO = selectedBuyerPOs.find(eachBuyerPO => selectedDispatchNoteBuyerPOIds.includes(eachBuyerPO.buyerPOId))
        
        let pmBillAddrId = ''
        let pmBillAddrStateId = 27 // By defualt it's maharastra
        if(relatedBuyerPO){
            pmBillAddrId = relatedBuyerPO.pmBillAddrId

            let relatedPMBillAddr = buyerCompanyPMBillAddrs.find(eachBillAddr => eachBillAddr.billAddrId === relatedBuyerPO?.pmBillAddrId)
            if (relatedPMBillAddr) {
                pmBillAddrStateId = relatedPMBillAddr.stateId
            }
        }

        if(!pmBillAddrId){
            return dispatch(raiseToast({severity:'warn', detail: "Buyer po doesn't have PM Bill Address", life: 3000}))
        }
        
        let newDeliveryChallan = []
        selectedBuyerPODispatchNotes.map(eachDispatchNote => {

            if(selectedInvoiceDispatchNotesIds.includes(eachDispatchNote.dispatchNoteId)){
                let relatedDispatchNoteItem = dispatchNoteItems.find(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === eachDispatchNote.dispatchNoteId)
                let relatedBuyerPO = selectedBuyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === relatedDispatchNoteItem.buyerPOId)

                if(!relatedBuyerPO){
                    return dispatch(raiseToast({severity:'warn', detail: "Buyer po not found for one of the dispatch note item", life: 3000}))
                }
                let deliveryChallanObj = {
                    dispatchNoteId: eachDispatchNote.dispatchNoteId,
                    createdAt: new Date(),
                    createdBy: userId,
                    docNo: relatedBuyerPO.docNo,
                    fileNo: relatedBuyerPO.fileNo,
                    pmBillAddrStateId: pmBillAddrStateId,
                    pmBillAddrId: pmBillAddrId,
                    billAddrId: selectedBuyerBillAddrId,
                    shipAddrId: selectedBuyerShipAddrId,
                }

                newDeliveryChallan.push(deliveryChallanObj)
            }
        })

        if (window.confirm("Are you sure you want to create Delivery Challan?")) {
            setIsLoading(true)
            let createDeliveryChallanResponse = await insertDeliveryChallan({ deliveryChallan: newDeliveryChallan })
            // console.log("createDeliveryChallan-response", createDeliveryChallanResponse)
            if (createDeliveryChallanResponse.failure) {
                setIsLoading(false)
                dispatch(raiseToast({ severity: 'error', detail: createDeliveryChallanResponse.data.error, life: 3000 }))
            } else {
                setIsLoading(false)
                props.setIsCreateDeliveryChallanModalVisible(false)
                dispatch(raiseToast({ severity: 'success', detail: "Delivery Challan Created Successfully", life: 3000 }))
                dispatch(fetchBuyerPOs({ ...searchParams }))
            }
        }
    }
    
    return (
        <div className="p-card py-2">
            <div className="flex space-between mb-2 mt-1" style={{ width: "100%", flex: 1, justifyContent: "space-between" }}>
                <div className='flex flex-row'>
                    <CheckboxField checked={selectedBuyerPODispatchNotes.length === selectedInvoiceDispatchNotesIds.length} onChange={(event) => handleAllDispatchCheckBox(event)} />
                    <label htmlFor="selectAllVendor" className="ml-2">Select All</label>
                </div>
            </div>
            {
                selectedBuyerPODispatchNotes?.map(dispatchNote => {
                    let relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === dispatchNote.dispatchNoteId)
                    return (
                        <DispatchNote
                            dispatchNote={dispatchNote}
                            handleAllDispatchCheckBox={handleAllDispatchCheckBox}
                            handleSelectDispatchCheckBox={handleSelectDispatchCheckBox}
                            selectedInvoiceDispatchNotesIds={selectedInvoiceDispatchNotesIds}
                            selectedInvoiceDispatchNotes={[]}
                            dispatchNoteItems={relatedDispatchNoteItems}
                            reqWiseGroupedDispatchNoteItems={reqWiseGroupedDispatchNoteItems}
                            selectedBuyerPOs={selectedBuyerPOs}
                        />
                    )
                })
            }
            <div className="py-1">
                <div className="hr-line"></div>
                <h5 className="text-600 my-2">Shipping Address</h5>
                <ShippingAddressCards shippingAddresses={buyerCompanyBranchShipAddrs} selectedAddressId={selectedBuyerShipAddrId} handleShippingAddress={handleShippingAddress} />
                <div className="hr-line"></div>
                <h5 className="text-600 my-2">Billing Address</h5>
                <BillingAddressCards billingAddresses={buyerCompanyBillAddrs} selectedAddressId={selectedBuyerBillAddrId} handleBillingAddress={handleBillingAddress} />
                <div className="hr-line mb-2"></div>
            </div>
            <div className='flex justify-content-end flex-row'>
                <Button className="small-btn" label="Create Delivery Challan" onClick={onSubmitCreateDeliveryChallan} />
            </div>
            <Loading visible={isLoading} />
        </div>
    );

}

export default CreateDeliveryChallan;